module.exports = __webpack_public_path__ + "static/media/icon.8bf7ac30.svg";